export const DiscountMessaging = function(collections, container) {
  try {
    if (!$('[data-discount-json]').html()) return;
    let discountJson = JSON.parse($('[data-discount-json]').html());
    discountJson.forEach(discount => {
      if (!discount.collections.length) return $(container).html(discount.productMessage);
      let discountCollections = discount.collections.split(',').map(el => el.trim());
      if (!collections) return;
      let collectionHandles = collections.split('|').map(el => el.trim());
      collectionHandles.forEach(collectionHandle => {
        discountCollections.forEach(discountCollection => {
          if (collectionHandle != discountCollection) return;
          $(container).html(discount.productMessage);
          return false;
        });
      });
    });
  } catch (error) {
    console.error(error);
  }
}